import * as z from "zod";
import { discountRescueInput } from "./discount-rescue-shared";

/**
 * The `checkout*` fields are the v2, checkout-grain view; they are nullish so a
 * client on this schema still validates a response from a server that predates
 * them. `claimRate`/`previousClaimRate` are the v1 event-grain rates, kept required
 * so an app bundle on the v1 schema keeps validating responses from this server.
 */
export const getDiscountRescueSummaryMetrics = {
  name: "getDiscountRescueSummaryMetrics" as const,
  input: discountRescueInput,
  output: z.object({
    failedDiscountsDetected: z.number(),
    rescuesClaimed: z.number(),
    claimRate: z.number(),
    previousRescuesClaimed: z.number(),
    previousClaimRate: z.number(),
    // Checkout-grain counts: each checkout counted once, so a range sum is a
    // distinct-checkout count. Rates are null (not 0) when nothing was shown.
    checkoutsWithFailedDiscount: z.number().nullish(),
    checkoutsShown: z.number().nullish(),
    checkoutsClaimed: z.number().nullish(),
    checkoutClaimRate: z.number().nullish(),
    previousCheckoutClaimRate: z.number().nullish(),
    // Completion cohort: trimmed of the most recent days, so its counts are
    // deliberately smaller than checkoutsWithFailedDiscount and must not be used as
    // that tile's value. Nullish for the same skew reason as above.
    attemptedCheckouts: z.number().nullish(),
    completedAfterFailedDiscount: z.number().nullish(),
    attempterCheckoutRate: z.number().nullish(),
    previousAttempterCheckoutRate: z.number().nullish(),
    // Order attribution (from the recovered-metrics mart). Revenue is in the
    // shop currency; the frontend formats it via CurrencyContext.
    impactedRevenue: z.number(),
    recoveredOrders: z.number(),
    avgRecoveredOrderValue: z.number(),
    previousImpactedRevenue: z.number(),
    previousRecoveredOrders: z.number(),
    previousAvgRecoveredOrderValue: z.number(),
  }),
};
